import React, { useEffect, useRef, useState } from "react";

export default function LatestAiDevelopment({ searchParam }) {
  const [header, setHeader] = useState([
    {
      title: "AI Chatbot",
      imgSrc: "AiPageImage1",
      accData: [
        {
          title: "The Core Technology",
          content:
            "Our AI chatbot technology is designed to improve customer service and simplify the user experience for online booking platforms. We have developed a powerful AI assistant that provides instant, 24/7 support.",
        },
        {
          title: "Real-World Application",
          content:
            "For a leading sports venue booking platform like Cricbuddy, our AI assistant helps users with queries about venue availability, pricing, and bookings.",
        },
        {
          title: "The Process",
          content:
            "We have automated the process of resolving user queries about venue availability, pricing, and bookings.",
        },
        {
          title: "Driving Business Growth",
          content:
            "Our solution not only optimizes operational efficiency for the platform but also drives higher conversion rates through guiding the users directly to a confirmed booking.",
        },
      ],
    },
    {
      title: "AI Voice Search",
      imgSrc: "AiPageImage2",
      accData: [
        {
          title: "Introducing Voice Search",
          content:
            "We are pleased to introduce our AI voice search solution, a powerful new feature that aims to transform user interaction and speed up the booking process for online platforms.",
        },
        {
          title: "Client Case Study",
          content:
            "We have developed a custom AI voice search solution for Cricbuddy. This technology allows users to find and book venues simply by speaking their queries, creating a fast and efficient experience that drives higher engagement.",
        },
        {
          title: "How It Works",
          content:
            "The AI instantly processes natural language requests from city and sub-location to sports category and venue to deliver highly accurate, targeted results.",
        },
        {
          title: "The Business Advantage",
          content:
            "This innovative solution significantly reduces search time and eliminates the need for typing and navigating through the platform.",
        },
      ],
    },
    {
      title: "AI-Powered Image Processing",
      imgSrc: "AiPageImage3",
      accData: [
        {
          title: "Our Solution",
          content:
            "For Superbuildup, we developed an AI-driven solution to automate payment management and reduce manual data entry for residential or business projects.",
        },
        {
          title: "How It Works",
          content:
            "Our feature uses advanced image processing to track payments directly from images of received cheques. The AI instantly reads key information, matches it against existing customer records in the database, and automatically adds the payment to the corresponding account record.",
        },
        {
          title: "Driving Business Efficiency",
          content:
            "This solution optimizes the payment tracking process for builders to deliver accuracy and free up their valuable time to focus on managing their projects.",
        },
        {
          title: "The Challenge",
          content:
            "Builders often struggle with manual payment processing, and it leads to more human errors. Our AI solution is developed to turn this lengthy process into a seamless, automated workflow.",
        },
      ],
    },
    {
      title: "Automated Sale Deed Generation",
      imgSrc: "AiPageImage4",
      accData: [
        {
          title: "Simplifying Legal Documentation",
          content:
            "We developed a feature for Superbuildup that automates the complex and time-consuming process of generating legal documents.",
        },
        {
          title: "User-Friendly Process",
          content:
            "Builders and users can simply enter the required data into our system, and our AI will process their details to instantly generate a professional, legally formatted document.Builders and users can simply enter the required data into our system, and our AI will process their details to instantly generate a professional, legally formatted document.",
        },
        {
          title: "How It Works",
          content:
            "Our AI solution uses a predefined format to process user-provided details and populate them into a standardized sale deed.",
        },
        {
          title: "Key Business Benefits",
          content:
            "This capability provides a powerful tool for automating legal documentation, delivering consistent results, and reducing the risk of manual errors.",
        },
      ],
    },
  ]);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const isMobile = window.innerWidth < 900;
  const scrollRef = useRef(null);
  useEffect(() => {
    if (isMobile) return;

    const timer = setTimeout(() => {
      setSelectedIndex(
        selectedIndex + 1 < header.length ? selectedIndex + 1 : 0
      );
    }, 8000);

    return () => clearTimeout(timer);
  }, [selectedIndex, header.length, isMobile]);

  // ✅ When selectedIndex changes on mobile, scroll active into view
  useEffect(() => {
    if (isMobile && scrollRef.current) {
      const activeEl = scrollRef.current.querySelector(".active");
      if (activeEl) {
        activeEl.scrollIntoView({
          behavior: "smooth",
          inline: "center",
          block: "nearest",
        });
      }
    }
  }, [selectedIndex, isMobile]);
  useEffect(() => {
    if (searchParam) {
      setSelectedIndex(
        header.findIndex((item) =>
          item.title
            .toLowerCase()
            .replaceAll(" ", "-")
            .includes(searchParam.toLowerCase().replaceAll(" ", "-"))
        ) !== -1
          ? header.findIndex((item) =>
              item.title
                .toLowerCase()
                .replaceAll(" ", "-")
                .includes(searchParam.toLowerCase().replaceAll(" ", "-"))
            )
          : 0
      );
    }
  }, []);
  return (
    <React.Fragment>
      <div className="row my-2 latestApiDevelopmentDiv">
        <div className="col-12 text-center py-4">
          <h2>Our Latest AI Development Work</h2>
        </div>
        <div className={`col-12 ${isMobile ? "px-0" : "px-6"}`}>
          {isMobile ? (
            <div className="position-relative d-flex align-items-center justify-content-center">
              {/* Left Arrow */}
              <button
                className="latestDevelopmentArrow latestDevelopmentArrowLeft my-0"
                onClick={() =>
                  setSelectedIndex(
                    selectedIndex === 0 ? header.length - 1 : selectedIndex - 1
                  )
                }
              >
                &#8249;
              </button>

              {/* Scrollable titles */}
              <div
                ref={scrollRef}
                className="d-flex align-items-center mx-5 latestDevelopmentTitleScroll"
                style={{ overflowX: "auto", whiteSpace: "nowrap" }}
              >
                {header?.map((item, index) => (
                  <p
                    key={index}
                    className={`latestDevelopmentTitleSpan mx-2 px-3 py-1 my-3 cursor-pointer ${
                      selectedIndex === index ? "active" : ""
                    }`}
                    onClick={() => setSelectedIndex(index)}
                  >
                    {item?.title}
                  </p>
                ))}
              </div>

              {/* Right Arrow */}
              <button
                className="latestDevelopmentArrow latestDevelopmentArrowRight my-0"
                onClick={() =>
                  setSelectedIndex(
                    selectedIndex === header.length - 1 ? 0 : selectedIndex + 1
                  )
                }
              >
                &#8250;
              </button>
            </div>
          ) : (
            <>
              <div className="d-flex justify-content-center align-items-center">
                {header?.map((item, index) => (
                  <span
                    key={index}
                    className={`latestDevelopmentTitleSpan mx-2 px-3 py-1 cursor-pointer ${
                      selectedIndex === index ? "active" : ""
                    }`}
                    onClick={() => {
                      setSelectedIndex(index);
                    }}
                  >
                    {item?.title}
                  </span>
                ))}
              </div>
            </>
          )}
        </div>
        <div className="col-12 px-6 mt-4">
          <AiChatComp
            accData={header[selectedIndex].accData}
            imgSrc={header[selectedIndex].imgSrc}
          />
        </div>
      </div>
    </React.Fragment>
  );
}
const AiChatComp = ({ accData, imgSrc }) => {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <React.Fragment>
      <div className="row mx-0 AiChatBotDiv align-items-center flex-md-row flex-column-reverse">
        <div className="col-md-7">
          <div className="accordion aiAcc" id="accordionExample">
            {accData?.map((item, index) => (
              <div
                className={`accordion-item border-bottom border-solid borderrRadius-0`}
                key={index}
              >
                <h3 className="accordion-header" id={`heading${index}`}>
                  <button
                    className={`accordion-button ps-0 ${
                      openIndex === index ? "" : "collapsed"
                    }`}
                    type="button"
                    onClick={() => setOpenIndex(index)}
                    aria-expanded={openIndex === index}
                    aria-controls={`collapse${index}`}
                  >
                    {item?.title}
                  </button>
                </h3>
                <div
                  id={`collapse${index}`}
                  className={`accordion-collapse collapse${
                    openIndex === index ? " show" : ""
                  }`}
                  aria-labelledby={`heading${index}`}
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body ps-0 d-flex flex-row">
                    <div className="me-3">
                      <img src="/images/AccDash.png" alt="" />
                    </div>
                    {item?.content}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="col-md-5">
          <img className="img-fluid" src={`/images/${imgSrc}.png`} alt="" />
        </div>
      </div>
    </React.Fragment>
  );
};
